<template>
    <row justify="center">
        <column shrink class="border-solid border border-accent rounded-full text-center"
                style="width: 730px; height: 730px;"
                align="center"
                justify="center"
                v-if="!mobile"
        >
            <divider color="accent" width="56" class="mb-1"></divider>
            <div class="text-white poppins-bold tracking-normal leading-highest text-5xl">Fitt Value Drivers</div>
            <div class="text-accent uppercase poppins-bold tracking-widest leading-tight">
                A premium people solution.
                <br>
                at scale
            </div>
            <div
                    v-for="({icon, text, angle, x, y}, itemIndex) of items"
                    :key="itemIndex"
                    :id="'fitt_value_driver_item_' + itemIndex"
                    class="absolute flex justify-center subpixel-antialiased"
            >
                <card round width="71" height="71" class="mb-3 flex justify-center items-center">
                    <icon :icon="icon" color="primary" size="lg"></icon>
                </card>
                <div class="uppercase text-white absolute bottom-0 transform translate-y-full w-64 poppins-bold tracking-wide leading-tight"
                     v-html="text"></div>
            </div>
        </column>
        <column v-else>
            <row justify="center" class="mb-12">
<!--                <column cols="full" align="center">-->
<!--                    <divider color="accent" width="56" class="mb-1"></divider>-->
<!--                </column>-->
                <column cols="full" align="center" class="text-white poppins-bold tracking-normal leading-highest text-3xl text-center">
                    Fitt Value Drivers
                </column>
                <column cols="full" align="center" class="text-accent uppercase poppins-bold tracking-widest leading-tight text-center">
                    A premium people solution.
                    <br>
                    at scale
                </column>
            </row>
            <row class="uppercase" align="stretch">
                <column v-for="(item, index) in items"
                        :key="index"
                        align="center"
                        xs="1/2"
                        sm="1/3"
                        md="1/4"
                        lg="1/6"
                        xl="1/8"
                        class="mb-12"
                >
<!--                    :md="'1/'+items.length"-->
                    <card round width="71" height="71" class="mb-3 flex justify-center items-center">
                        <icon :icon="item.icon" color="primary" size="lg"></icon>
                    </card>
                    <div class="text-white text-center poppins-bold tracking-wide leading-tight"
                           style="max-width: 170px;"
                           v-html="item.text"
                    ></div>
                </column>
            </row>
        </column>
    </row>
</template>

<script>
    import anime from 'animejs/lib/anime.es.js';
    import Helpers from "../../mixins/Helpers";

    export default {
        mixins: [Helpers],
        components: {
            'icon': () => import('@/components/display/Icon.vue'),
            // 'btn': () => import('@/components/Btn.vue'),
            'divider': () => import('@/components/Divider.vue'),
            card: () => import('@/components/Card.vue'),
        },
        data: () => ({
            // coords: {
            //     0: {y: "0vh", x: "35vh"},
            //     45: {y: "24.74873734152916vh", x: "24.748737341529164vh"},
            //     90: {y: "35vh", x: "0vh"}
            // },
            items: [
                {
                    icon: 'account-check',
                    text: 'premium candidate <br> experience',
                    angle: 1,
                },
                {
                    icon: 'file-document',
                    text: 'multi-level <br> application',
                    angle: 45,
                },
                {
                    icon: 'account-check',
                    text: 'integrated across <br> assessments',
                    angle: 90,
                },
                {
                    icon: 'poll-box-outline',
                    text: 'expert input on <br> every profile',
                    angle: 135,
                },
                {
                    icon: 'desktop-mac-dashboard',
                    text: 'fully digital <br> journeys',
                    angle: 180,
                },
                {
                    icon: 'security',
                    text: 'secure data <br> management',
                    angle: 225
                },
                {
                    icon: 'chart-line-variant',
                    text: 'versatile and <br> customizable',
                    angle: 270,
                },
                {
                    icon: 'clipboard-text',
                    text: 'multi-dimensional <br> reporting',
                    angle: 315,
                },
            ],
            innerWidth: 0
        }),
        computed: {
            mobile() {
                return this.innerWidth <= 940;
            }
        },
        methods: {
            setInnerWidth() {
                this.innerWidth = window.innerWidth;
                this.renderCircle();
            },
            getTransformStyle(angle) {
                const radius = 365;//radius;
                let radians = (Math.PI / 180) * angle,
                    x = Math.sin(radians) * radius,
                    y = -Math.cos(radians) * radius;

                return {
                    translateY: (y.toFixed(4)) + 'px',
                    translateX: (x.toFixed(4)) + 'px',
                    translateZ: 0,
                };
            },
            renderCircle() {
                //TODO: Hard code this object or make dynamic based on circle radius
                this.coords = {};
                for (let i = 0; i <= 360; i++) {
                    this.coords[i] = this.getTransformStyle(i);
                }
                let intArray = Array(361).fill().map((x, i) => i);
                setTimeout(() => {
                    this.items.forEach(({angle}, index) => anime({
                        targets: '#fitt_value_driver_item_' + index,//TODO: Optimize, capture indexOf in variable
                        keyframes: intArray.slice(intArray.indexOf(angle)).concat(intArray.slice(0, intArray.indexOf(angle))).reduce((keyframes, currentInt, currentIntIndex) => {
                            if (currentInt !== 0) {
                                keyframes.push(Object.assign(this.coords[currentInt], {
                                    duration: currentIntIndex === 0 ? 100 : 1000,
                                    delay: currentIntIndex === 0 ? 100 : 0,
                                }));
                            }
                            return keyframes;
                        }, []),
                        loop: true,
                        easing: 'linear',
                    }));
                }, 400);
            }
        },
        mounted() {
            window.addEventListener('resize', this.debounce(this.setInnerWidth, 500));
            this.setInnerWidth();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setInnerWidth);
        }
    };
</script>